import React, { useState, useEffect, useContext } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const JmsList = ({ getJmsList, jmsList = {} }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const { baseUrl } = useContext(BaseUrl);

  const headers = [
    "PO No",
    "Site No",
    "Site Name",
    "Sub Total",
    "Total",
    "Status",
    "Created By",
    "Action"
  ];

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        await getJmsList(1);
      } catch (error) {
        console.error("Error fetching JMS list:", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    const tableData = [
      "po_no",
      "site_no",
      "site_name",
      "sub_total",
      "total",
      "status_text",
      "created_by_name"
    ];

    if (jmsList && jmsList?.data) {
      const data = jmsList.data.map((element) => {
        const actions = [
          {
            name: 'View Details',
            link: `${baseUrl}/submit-jms/${element.site_id}/${element.lead_id}/${element.id}`
          },
        ];

        return Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key],
          })),
          {
            Action: actions
          }
        );
      });

      setListData(data);

      setPageCount(
        Math.ceil(jmsList?.total / jmsList?.per_page)
      );
    }
  }, [jmsList]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getJmsList(val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title="JMS Approval"
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
      />
    </Layout>
  );
};

export default JmsList;